import React, { useState, useEffect } from 'react';
import { DollarSign, ChartColumn } from 'lucide-react';
import '../CryptoCard.css';

const CryptoCard = ({ selectedCrypto }) => {
    const [cryptoData, setCryptoData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const requestOptions = {
                method: 'GET',
                redirect: 'follow',
                headers: {
                    Authorization: `Bearer ${process.env.REACT_APP_COINCAP_API_KEY}`
                }
            };
            try {
                const response = await fetch(`https://rest.coincap.io/v3/assets/${selectedCrypto}`, requestOptions);
                
                if (!response.ok) {
                    console.error('Response status:', response.status, response.statusText);
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const result = await response.json();
                const entry = result.data;
                const formattedData = {
                    symbol: entry.symbol,
                    price: parseFloat(entry.priceUsd).toFixed(2),
                    changePercent: parseFloat(entry.changePercent24Hr).toFixed(2),
                    marketCap: formatNumber(entry.marketCapUsd),
                    volume24h: formatNumber(entry.volumeUsd24Hr),
                };

                setCryptoData(formattedData);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };

        fetchData();
    }, [selectedCrypto]);

    const formatNumber = (number) => {
        if (!number) return 'NA';
        const num = parseFloat(number);
        if (num >= 1e9) return `${(num / 1e9).toFixed(2)} B`;
        if (num >= 1e6) return `${(num / 1e6).toFixed(2)} M`;
        return num.toLocaleString();
    };

    return cryptoData ? (
        <>
            <div className="m-2 p-8 rounded-xl w-full bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700">
                <div>
                <h2 style={{fontSize: '30px', fontWeight: 'bold', marginBottom: '10px'}}>${cryptoData.price}</h2>
                <p className='change' style={{fontSize: '17px', color: cryptoData.changePercent >= 0 ? 'lime' : 'red', backgroundColor: cryptoData.changePercent >= 0 ? 'var(--green)' : 'rgba(87, 44, 44, 0.5)'}}>{cryptoData.changePercent}%</p>
                <p className='name'> 
                    {selectedCrypto.charAt(0).toUpperCase() + selectedCrypto.slice(1)}</p>
                <p className='symbol'>{cryptoData.symbol}</p>
                </div>
            </div>
            <div className="m-2 p-4 rounded-xl w-full bg-color1 shadow-[0_0_10px_rgba(0,0,0,0.3)] dark:bg-gradient-to-br dark:from-[#09090b] dark:to-zinc-800 dark:border dark:border-zinc-700">
                <span className="ml-2 px-2 py-0.5 text-xs bg-green-500 text-white rounded-full">24h</span>
                <div className='flexcard p-4'>
                    <div>
                        <DollarSign color="#9CA3AF" />
                        <p className='text-lg text-gray-400 my-4'>Market Cap:</p>
                        <p className='text-2xl font-bold'>{cryptoData.marketCap}</p>
                    </div>
                    <div>
                        <ChartColumn color="#9CA3AF" />
                        <p className='text-lg text-gray-400 my-4'>Volume:</p>
                        <p className='text-2xl font-bold'>{cryptoData.volume24h}</p>
                    </div>
                </div>
            </div>
        </>
    ) : (
        <p>Loading...</p>
    );
};

export default CryptoCard;
